import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

const Root = styled(Box)({
  minHeight: '100vh',
  backgroundColor: 'var(--ds-canvas)',
  color: 'var(--ds-ink)',
  fontFamily: 'var(--ds-font)',
})

export function AlbumImmersiveLayout() {
  return (
    <Root className='ds-canvas'>
      <Outlet />
    </Root>
  )
}
